import { render, staticRenderFns } from "./addCourseCtrHainan.vue?vue&type=template&id=1863670b&scoped=true"
import script from "./addCourseCtrHainan.vue?vue&type=script&lang=js"
export * from "./addCourseCtrHainan.vue?vue&type=script&lang=js"
import style0 from "./addCourseCtrHainan.vue?vue&type=style&index=0&id=1863670b&prod&lang=less"
import style1 from "./addCourseCtrHainan.vue?vue&type=style&index=1&id=1863670b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1863670b",
  null
  
)

export default component.exports